var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54167 7.95833H13.4583M5.54167 11.125H9.5M16.625 16.6667L13.9933 15.3508C13.7938 15.251 13.694 15.2011 13.5894 15.166C13.4967 15.1348 13.4011 15.1122 13.3041 15.0986C13.1949 15.0833 13.0833 15.0833 12.8603 15.0833H4.90833C4.02158 15.0833 3.57821 15.0833 3.23952 14.9107C2.94159 14.759 2.69937 14.5167 2.54758 14.2188C2.375 13.8802 2.375 13.4367 2.375 12.55V6.53333C2.375 5.64658 2.375 5.20321 2.54758 4.86452C2.69937 4.56659 2.94159 4.32437 3.23952 4.17258C3.57821 4 4.02159 4 4.90833 4H14.0917C14.9784 4 15.4218 4 15.7605 4.17258C16.0584 4.32437 16.3007 4.56659 16.4524 4.86452C16.625 5.20321 16.625 5.64659 16.625 6.53333V16.6667Z",
    stroke: "#8161EB",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusText);
export default __webpack_public_path__ + "static/media/status_text.f2b2ae918da9ef5f01f4a6a5fa35640e.svg";
export { ForwardRef as ReactComponent };